module.exports = __webpack_public_path__ + "static/images/containers/BattleRooms/components/Squad/images/tr-background.51d94c8e.png";


//////////////////
// WEBPACK FOOTER
// ./containers/BattleRooms/components/Squad/images/tr-background.png
// module id = 2743
// module chunks = 11